let DISABLED_PRODUCT_ID

switch(process.env.REACT_APP_ENV) {
    case 'acceptation':
    case 'area51':
    case 'development': {
        DISABLED_PRODUCT_ID = 24242
        break;
    }
    // Production
    default: {
        DISABLED_PRODUCT_ID = 24635
        break;
    }
}

export {
    DISABLED_PRODUCT_ID
}